module.exports = __webpack_public_path__ + "img/20230803092804617zfd.39e02770.jpg";